/*!
 * Copyright (c) 2017-present Ghostery GmbH. All rights reserved.
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */
/* eslint-disable prettier/prettier */
export default [
    ".cloudfront.net",
    "googlesyndicati",
    "imasdk.googleap",
    ".actonservice",
    "analytics.",
    "marketing.",
    "tracking.",
    ".website",
    "metrics.",
    ".online",
    "images.",
    ".co.uk",
    ".space",
    "a8clk.",
    "stats.",
    ".cyou",
    ".shop",
    ".site",
    "a8cv.",
    "track",
    ".cfd",
    ".com",
    ".net",
    ".pro",
    ".xyz",
    "www.",
    ".au",
    ".de",
    ".jp",
    ".qp",
    "app",
    "cdn",
    ".b",
    ".c",
    ".f",
    ".h",
    ".k",
    ".l",
    ".m",
    ".n",
    ".p",
    ".s",
    ".w",
    "a1",
    "a2",
    "a4",
    "ab",
    "ac",
    "ad",
    "af",
    "ag",
    "ah",
    "ak",
    "al",
    "am",
    "an",
    "ap",
    "ar",
    "as",
    "at",
    "au",
    "av",
    "aw",
    "ax",
    "ay",
    "az",
    "be",
    "bl",
    "bo",
    "br",
    "bu",
    "ca",
    "ce",
    "ch",
    "ci",
    "ck",
    "cl",
    "cr",
    "ct",
    "cu",
    "de",
    "di",
    "dk",
    "dl",
    "dn",
    "do",
    "dr",
    "ds",
    "dy",
    "e-",
    "eb",
    "ec",
    "ed",
    "ef",
    "eg",
    "ek",
    "el",
    "em",
    "en",
    "ep",
    "er",
    "es",
    "et",
    "eu",
    "ev",
    "ew",
    "ex",
    "ey",
    "ff",
    "fi",
    "fl",
    "fo",
    "fr",
    "ge",
    "gl",
    "go",
    "gr",
    "gs",
    "gu",
    "gy",
    "he",
    "ho",
    "ia",
    "ib",
    "ic",
    "id",
    "if",
    "ig",
    "ik",
    "il",
    "im",
    "in",
    "io",
    "ip",
    "iq",
    "ir",
    "is",
    "it",
    "iv",
    "ix",
    "iz",
    "jo",
    "ks",
    "le",
    "li",
    "ll",
    "lo",
    "ly",
    "ma",
    "me",
    "mo",
    "mp",
    "my",
    "no",
    "ob",
    "ok",
    "ol",
    "om",
    "on",
    "oo",
    "op",
    "or",
    "ot",
    "ph",
    "pl",
    "po",
    "pr",
    "qu",
    "re",
    "ro",
    "ru",
    "ry",
    "s-",
    "sc",
    "se",
    "sh",
    "si",
    "sk",
    "sl",
    "sn",
    "so",
    "sp",
    "ss",
    "st",
    "sw",
    "sy",
    "t-",
    "ta",
    "te",
    "th",
    "ti",
    "tn",
    "to",
    "tr",
    "ts",
    "tu",
    "tv",
    "tw",
    "ty",
    "ub",
    "ud",
    "ug",
    "uk",
    "ul",
    "um",
    "un",
    "up",
    "ur",
    "us",
    "ut",
    "ve",
    "vi",
    "vo",
    "we",
    "wn",
    "yo",
    "-",
    ".",
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z"
];
//# sourceMappingURL=network-hostname.js.map